export const MEDIUM_BREAKPOINT_QUERY = '(min-width: 768px)';
